import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  progress: 0,
  status: '',
  steps: [],
  currentStep: 0,
  isActive: false,
  isAnimating: false,
  targetSocketId: null,
};

const coercePayload = (updates) => {
  if (!updates) return {};
  if (updates.payload) return updates.payload;
  if (updates.data) return updates.data;
  return updates;
};

const normalizeStartPayload = (payload) => {
  if (!payload) {
    return { steps: [], socketId: null };
  }
  if (Array.isArray(payload)) {
    return { steps: payload, socketId: null };
  }
  if (typeof payload === 'object') {
    return {
      steps: payload.steps || [],
      socketId: payload.socketId || null,
    };
  }
  return { steps: [], socketId: null };
};

const shouldProcessMessage = (state, data) => {
  if (!data) return true;
  const messageSocketId = data.socket_id;
  if (!messageSocketId) {
    return true;
  }
  if (!state.targetSocketId) {
    state.targetSocketId = messageSocketId;
    return true;
  }
  return state.targetSocketId === messageSocketId;
};

const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    reset(state) {
      state.progress = 0;
      state.status = '';
      state.steps = [];
      state.currentStep = 0;
      state.isActive = false;
      state.isAnimating = false;
      state.targetSocketId = null;
    },
    start(state, { payload }) {
      const { steps, socketId } = normalizeStartPayload(payload);
      state.steps = steps;
      state.progress = 0;
      state.currentStep = 0;
      state.status = 'Starting process...';
      state.isActive = true;
      state.isAnimating = false;
      state.targetSocketId = socketId || state.targetSocketId;
    },
    updateFromServer(state, { payload }) {
      const data = coercePayload(payload);
      if (!shouldProcessMessage(state, data)) {
        return;
      }
      if (data.progress !== undefined) {
        state.progress = data.progress;
        state.isActive = true;
      }
      if (data.status !== undefined) state.status = data.status;
      if (data.currentStep !== undefined) state.currentStep = data.currentStep;
      if (data.steps !== undefined) state.steps = data.steps;
    },
    complete(state, { payload }) {
      const data = coercePayload(payload) || {};
      if (!shouldProcessMessage(state, data)) {
        return;
      }
      state.progress = 100;
      state.status = data.status || 'Processing complete!';
      state.isAnimating = true;
      state.isActive = false;
      if (data.socket_id) {
        state.targetSocketId = data.socket_id;
      }
    },
  },
});

export const { reset, start, updateFromServer, complete } = progressSlice.actions;
export default progressSlice.reducer;


